export default __webpack_public_path__ + "static/media/Avatar-8-noback.50f6fd84.png";